{
  "name": "sites-builder-app",
  "version": "1.7.0",
  "scripts": {
    "ng": "ng",
    "dev": "ng serve --configuration development --ssl",
    "dev:mobile": "ng serve --host 0.0.0.0 --allowed-hosts local.3ddigitalvenue.com --public-host local.3ddigitalvenue.com --configuration development",
    "start": "ng serve --host local.3ddigitalvenue.com --open --ssl true",
    "start:local": "ng serve --host local.3ddigitalvenue.com --configuration local --open --ssl true",
    "start:prod": "ng serve --host local.3ddigitalvenue.com --configuration production --open --ssl true",
    "build": "ng build",
    "build:dev": "ng build --configuration development",
    "build:pre": "ng build --configuration preproduction",
    "build:prod": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@3ddv/dvm-internal": "^2.8.0",
    "@3ddv/ngx-dvm-internal": "^5.0.0",
    "@angular/animations": "^21.2.17",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.17",
    "@angular/compiler": "^21.2.17",
    "@angular/core": "^21.2.17",
    "@angular/forms": "^21.2.17",
    "@angular/platform-browser": "^21.2.17",
    "@angular/platform-browser-dynamic": "^21.2.17",
    "@angular/router": "^21.2.17",
    "@floating-ui/dom": "^1.6.13",
    "@splidejs/splide": "^4.1.4",
    "@tailwindcss/postcss": "^4.0.6",
    "@tiptap/core": "^3.7.2",
    "@tiptap/extension-heading": "^3.7.2",
    "@tiptap/starter-kit": "^3.7.2",
    "animejs": "^3.2.2",
    "lodash-es": "^4.17.21",
    "postcss": "8.5.15",
    "rxjs": "~7.8.2",
    "tailwindcss": "^4.0.6",
    "tslib": "^2.3.0",
    "zod": "^3.24.3",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.15",
    "@angular/cli": "^21.2.15",
    "@angular/compiler-cli": "^21.2.17",
    "@types/animejs": "^3.1.13",
    "@types/lodash-es": "^4.17.12",
    "@vitest/coverage-v8": "^4.1.5",
    "angular-eslint": "^21.3.1",
    "eslint": "^9.23.0",
    "jsdom": "^29.0.2",
    "schematics": "file:schematics",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.59.0",
    "vitest": "^4.1.5"
  },
  "overrides": {
    "@babel/core": "7.29.7",
    "@angular-devkit/build-angular": {
      "tailwindcss": "^4.0.6"
    },
    "esbuild": "0.28.1",
    "fast-uri": "4.0.0",
    "follow-redirects": "1.16.0",
    "postcss": "8.5.15",
    "uuid": "11.1.1",
    "vite": "7.3.5",
    "webpack-dev-server": "5.2.5",
    "ws": "8.21.0"
  }
}
